import React, { useState } from 'react';
import { Container, Header, ExpandButton, IconContainer } from '../../Tabs.styles';
import CustomTitle from '../../../CustomTitle/index';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { hexToRgba } from '../../../../../utils/helpers';
import AudioBlock from '../../../../SegmentBuilder/Shared/AudioBlock';
import { AudioContainer } from './CollapsibleAudios.styles';

const CollapsibleAudios = ({ audios = [], icon, title, segmentColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    if (audios.length > 1) {
      setIsExpanded(!isExpanded);
    }
  };

  const visibleAudios = isExpanded ? audios : audios.slice(0, 2);

  return (
    <Container>
      <Header>
        <IconContainer bgColor={segmentColor}>{/* <FaChevronDown />  */}</IconContainer>
        <CustomTitle title={title} count={audios.length} />
        <ExpandButton showIcon={audios.length > 1} onClick={toggleExpand}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </ExpandButton>
      </Header>

      <AudioContainer
        bgColor={hexToRgba(segmentColor, 0.5)}
        isExpanded={isExpanded}
        audiosLength={audios.length}
      >
        {visibleAudios.map((audio, index) => (
          <AudioBlock
            key={index}
            audio={audio}
            textColor={'black'}
            backgroundColor={hexToRgba(segmentColor, 0.4)}
            waveColor={segmentColor}
            iconColor={segmentColor}
          />
        ))}
      </AudioContainer>
    </Container>
  );
};

export default CollapsibleAudios;
